import bardiEats from "./projectImg/bardiEats.png";
import bardiMate from "./projectImg/BardiMate.png";
import codeBook from "./projectImg/codebook.png";
import dashboard from "./projectImg/dashboard.png";
import shopcart from "./projectImg/shopcart.png";
import taskimg from "./projectImg/taskMate.jpg";
import wrotenode from "./projectImg/writenode.png";

export const websites = [
    {
    id: 1,
    name: 'Bardi Eats',
    src: bardiEats,
    link: 'https://bardieats.netlify.app/'
    },

    {
        id: 2,
        name: 'BardiMate',
        src: bardiMate,
        link: 'https://bardimate-movie.netlify.app/'
    },

    {
        id: 3,
        name: 'Shopping',
        src: shopcart,
        link: 'https://shopmate-ln.netlify.app/'
    },
    {
        id: 4,
        name: 'CodeBook E-commerce',
        src: codeBook,
        link: 'https://codebook-bardi.netlify.app/'
    },
    {
        id: 5,
        name: 'BardiWrite',
        src: wrotenode,
        link: 'https://bardiwrite.netlify.app/'
    },
    {
        id: 6,
        name: 'Dashboard app',
        src: dashboard,
        link: 'https://bardidashbord.netlify.app/'
    },
    {
        id: 7,
        name: 'Task Mate',
        src: taskimg,
        link: 'https://taskmate-bardi.netlify.app/'
    },
    
]